import React from "react"
import { Link } from '@mui/material'
import "./imagecard.css"

const ImageCard = ({ title, image, country, city, hover }) => {
    const hoverEffectStar = `star-svg ${hover ? "onhover" : ""}`
    const hoverScale = `stars-container ${hover ? "onhover" : ""}`
    const hoverSubtitle = `subtitle ${hover ? "onhover" : ""}`
    console.log("hover: ", hover)
    return (
        <Link
            underline="none"
            href={`/tours/${city}`}
            color="primary.contrastText"
            title={"Ver todos los tours privados disponibles en " + title}
        >
            <div className="card">
                <div className="rating stars-container">
                    <span className="star">&#9733;</span>
                    <span className="star">&#9733;</span>
                    <span className="star">&#9733;</span>
                    <span className="star">&#9733;</span>
                    <span className="star">&#9733;</span>
                </div>
                <div className="subtitle">
                    <h1 className="card-title hover-effect">{title}</h1>
                </div>
                <img
                    src={image?.src || require('../../assets/images/new-york.jpg')}
                    alt={image?.caption || "Tours Privados a medida en " + title}
                    className="card-image"
                />
                <div className="card-overlay"></div>
            </div>
        </Link>
    )
}

export default ImageCard
